"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
const functions_1 = require("@/order/payment_detail/functions");
function default_1({ errorCode, setPaymentDetail, confirm, isRefund, isForceComplete, isLeaderReview, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const errorCodeReasonMapping = {
            40001: () => i18next_1.default.t('이미 작성된 리뷰가 있음'),
            40002: () => i18next_1.default.t('판매가 취소됨'),
            40003: () => (isLeaderReview ? i18next_1.default.t('진행중인 환불이 있음') : i18next_1.default.t('운송장이 등록됨')),
            40004: () => i18next_1.default.t('자동으로 구매가 취소된 폼'),
            40005: () => i18next_1.default.t('환불 신청 또는 완료 이력이 있음'),
            40006: () => i18next_1.default.t('양도된 폼'),
            40007: () => i18next_1.default.t('결제 대기중인 폼'),
            40008: () => i18next_1.default.t('판매자가 아직 판매 진행중'),
        };
        yield (0, functions_1.refetchPaymentDetail)({ setPaymentDetail });
        const errorConfirm = (description) => (0, errors_1.alertConfirm)({ confirm, description });
        if (isLeaderReview) {
            if (errorCode === 40001) {
                errorConfirm(i18next_1.default.t('이미 작성된 리뷰가 있어요.'));
            }
            else {
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('리뷰를 남길 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), `(${i18next_1.default.t('사유')}: ${errorCodeReasonMapping[errorCode]()})`] }));
            }
        }
        else if (isRefund && errorCode === 40005) {
            errorConfirm(i18next_1.default.t('이미 환불 요청 되었어요.'));
        }
        else {
            errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t(isForceComplete ? '배송 받았어요 실패!' : '환불을 요청할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), `(${i18next_1.default.t('사유')}: ${errorCodeReasonMapping[errorCode]()})`] }));
        }
    });
}
exports.default = default_1;
